import React from "react";
import { cx } from "../utils";

const CcSkeletonBlock = ({ lines = 4, className }) => (
  <div className={cx("cc-card", className)}>
    <div className={cx("cc-card__body", "cc-skeleton")} aria-busy="true">
      {Array.from({ length: lines }).map((_, index) => (
        <span
          className="cc-skeleton__line"
          key={index}
          style={{ width: `${index === 0 ? 58 : 86 - index * 8}%` }}
        />
      ))}
    </div>
  </div>
);

export default CcSkeletonBlock;
